import { COMMON } from '#app/theme/constants.js';
import { sx } from '#app/theme/utils.js';
import { type ListItemProps } from './types.js';
import { css, styled } from 'styled-components';

export const ListItem = styled.li<ListItemProps>`
  ${({
    isAlone = false,
    isDisabled = false,
    isHighlighted,
    isPinned = false,
    isSelected,
    theme,
  }) => css`
    background-color: ${theme.colorsV2.white};
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    font-size: 1rem;
    line-height: 1.5;
    min-width: max-content;
    cursor: pointer;

    &:hover {
      background-color: ${theme.colorsV2.gray05};
    }

    ${isSelected &&
    css`
      background-color: ${theme.colorsV2.gray05};
    `}

    ${isHighlighted &&
    css`
      background-color: ${theme.colorsV2.gray05};
    `}

    ${isDisabled &&
    css`
      cursor: not-allowed;
      color: ${theme.colorsV2.gray50};
      background-color: ${theme.colorsV2.white} !important;
    `}

    

    ${isPinned &&
    css`
      position: absolute;
      bottom: 0;
      width: 100%;
      z-index: 1;
      border-top: 1px solid ${theme.colorsV2.gray20};
      border-radius: 0 0 10px 10px;

      ${isAlone &&
      css`
        bottom: -48px;
      `}
    `}
  `}
  ${COMMON}
  ${sx}
`;
